import heroBubblePopSound1 from "../assets/home-vout3/Boobp1.mp3";
import heroBubblePopSound2 from "../assets/home-vout3/Boobp2.mp3";
import heroBubblePopSound3 from "../assets/home-vout3/Boobp3.mp3";

const HERO_BUBBLE_POP_SOUNDS = [
  heroBubblePopSound1,
  heroBubblePopSound2,
  heroBubblePopSound3,
];
const POOL_SIZE_PER_SOUND = 2;

const soundPools = HERO_BUBBLE_POP_SOUNDS.map(() => []);
let isPreloading = false;
let isPreloaded = false;
let isAudioUnlocked = false;
let unlockListenersBound = false;

const createAudio = (src) => {
  const audio = new Audio(src);
  audio.preload = "auto";
  audio.load();
  return audio;
};

const waitForAudioReady = (audio) =>
  new Promise((resolve) => {
    if (audio.readyState >= HTMLMediaElement.HAVE_ENOUGH_DATA) {
      resolve();
      return;
    }

    const finish = () => {
      audio.removeEventListener("canplaythrough", finish);
      audio.removeEventListener("loadeddata", finish);
      audio.removeEventListener("error", finish);
      resolve();
    };

    audio.addEventListener("canplaythrough", finish, { once: true });
    audio.addEventListener("loadeddata", finish, { once: true });
    audio.addEventListener("error", finish, { once: true });
  });

export const preloadHeroBubblePopSounds = () => {
  if (typeof Audio === "undefined" || isPreloading || isPreloaded) {
    return Promise.resolve();
  }

  isPreloading = true;

  const preloadPromise = Promise.all(
    HERO_BUBBLE_POP_SOUNDS.map(async (soundUrl, soundIndex) => {
      if (soundPools[soundIndex].length) {
        return;
      }

      const pool = Array.from({ length: POOL_SIZE_PER_SOUND }, () =>
        createAudio(soundUrl)
      );
      soundPools[soundIndex] = pool;
      await Promise.all(pool.map((audio) => waitForAudioReady(audio)));
    })
  ).finally(() => {
    isPreloading = false;
    isPreloaded = true;
  });

  return preloadPromise;
};

const unlockHeroBubbleAudio = async () => {
  if (isAudioUnlocked || typeof window === "undefined") {
    return;
  }

  await preloadHeroBubblePopSounds();

  const unlockAttempts = soundPools.flat().map(async (audio) => {
    const previousVolume = audio.volume;
    audio.volume = 0;

    try {
      await audio.play();
      audio.pause();
      audio.currentTime = 0;
    } catch (_) {
      // Browser may still block until a direct user gesture hits play().
    } finally {
      audio.volume = previousVolume;
    }
  });

  await Promise.all(unlockAttempts);
  isAudioUnlocked = true;
};

export const bindHeroBubbleAudioUnlock = () => {
  if (typeof window === "undefined" || unlockListenersBound) {
    return () => {};
  }

  unlockListenersBound = true;

  const unlock = () => {
    unlockHeroBubbleAudio();
    window.removeEventListener("pointerdown", unlock);
    window.removeEventListener("keydown", unlock);
    window.removeEventListener("touchstart", unlock);
  };

  window.addEventListener("pointerdown", unlock, { passive: true });
  window.addEventListener("keydown", unlock);
  window.addEventListener("touchstart", unlock, { passive: true });

  return () => {
    window.removeEventListener("pointerdown", unlock);
    window.removeEventListener("keydown", unlock);
    window.removeEventListener("touchstart", unlock);
    unlockListenersBound = false;
  };
};

export const playHeroBubblePopSound = () => {
  unlockHeroBubbleAudio();
  preloadHeroBubblePopSounds();

  const soundIndex = Math.floor(Math.random() * HERO_BUBBLE_POP_SOUNDS.length);
  const pool = soundPools[soundIndex];
  const audio =
    pool.find((item) => item.paused) ??
    createAudio(HERO_BUBBLE_POP_SOUNDS[soundIndex]);

  audio.currentTime = 0;
  audio.play().catch(() => {});
};

if (typeof window !== "undefined") {
  preloadHeroBubblePopSounds();
  bindHeroBubbleAudioUnlock();
}
